import { RequestError, RequestErrorType } from './generic-errors';
import { Mzp } from './mzp.type';

export function checkMembershipErrorsMzpSystem(error: Mzp.MembershipError, obj: any) {
  if (error) {
    throw new RequestError(RequestErrorType.MembershipError, obj);
  }
}
